<template>
  <div class="bg-secondary-dark p-4 flex justify-between items-center rounded">
    <p class="text-white">
      <slot />
    </p>
    <Button color="primary">Upgrade Now</Button>
  </div>
</template>

<script>
 
export default {
  name: 'Banner',
  props: {}
}

</script>

<style module>

</style>
